import React from 'react';
import Popper from '@material-ui/core/Popper';
import { CloseIcon, SurgeIcon } from '../../components/Icons';
import Fade from '@material-ui/core/Fade';
import { decimalChecker } from 'spwa-ui-library/esm/utils/helper';
import ClassNames from 'classnames';
import { Redux, Slices } from 'spwa-ui-library';
import css from './index.module.scss';
import { useIntl } from 'react-intl';

const { useSelector } = Redux;
const { selectCurrentCountry } = Slices.profileSlice;
const { selectCountryValidations } = Slices.configSlice;

function InfoPopper({ subTotal, cartAmount, anchor, langLabel, handleClose, currency }) {
  const intl = useIntl();
  const country = useSelector(selectCurrentCountry);
  const countryValidations = useSelector((state) => selectCountryValidations(state, country));

  return (
    <Popper
      id={cartAmount.type}
      open={true}
      placement="top-start"
      anchorEl={anchor}
      transition
      modifiers={{
        flip: {
          enabled: true,
        },
        preventOverflow: {
          enabled: true,
          boundariesElement: 'scrollParent',
        },
        arrow: {
          enabled: true,
        },
      }}
    >
      {({ TransitionProps }) => (
        <Fade {...TransitionProps} timeout={350}>
          <div className={css.tolltip}>
            <div className={css.closeIcon} onClick={() => handleClose(cartAmount.type)}>
              <CloseIcon />
            </div>
            {cartAmount.type === 'SHIPPING' ? (
              <>
                {cartAmount?.deliverybreakup?.length ? (
                  <>
                    <h4>{countryValidations?.deliveryFeeBreakupTitle}</h4>
                    <div className={css.dpodValues}>
                      {cartAmount.deliverybreakup.map((itm) => {
                        return (
                          <div
                            className={ClassNames(css.valItm, {
                              [css.discountVal]: itm.type === 'discount',
                            })}
                          >
                            <div className={css.valLabel}>{itm.label[langLabel]}</div>
                            <div className={css.valueAmount}>
                              {itm.type === 'surcharge' ? (
                                <>
                                  <SurgeIcon />{' '}
                                </>
                              ) : (
                                ''
                              )}
                              {decimalChecker(itm.value)} {currency}
                            </div>
                          </div>
                        );
                      })}
                    </div>
                  </>
                ) : (
                  <h5>{countryValidations?.deliveryFeeBreakup}</h5>
                )}
              </>
            ) : null}
            {cartAmount.type === 'SMALL_ORDER_FEE' ? (
              <>
              <h4>{(countryValidations?.smallOrderFeeTitle?.[langLabel] || "").replace('{amount}', `${subTotal+cartAmount.bannerAmountForFreeSmallOrderFee} ${currency}`)}</h4>
              <div className={css.dpodValues}>
                <div
                  className={ClassNames(css.valItm)}
                >
                  <div className={ClassNames(css.smallCartFee)}>
                    <span className={css.redText}>
                      {intl.formatMessage({id: 'add_items_worth_amount'}, {amount: cartAmount.bannerAmountForFreeSmallOrderFee, currency})}
                      </span>
                      <span>
                      {intl.formatMessage({id: 'or_more_to_remove_small_order_fee'})}
                    </span>
                  </div>
                </div>
              </div>          
              </>
            ) : null}
          </div>
        </Fade>
      )}
    </Popper>
  );
}

export default InfoPopper;
